'use strict';

class BlurConEnterDirective {


    constructor() {

    }

    link(scope, element, attrs) {

        element.bind("keyup",  (event) =>{
            if (event.which === 13) {
                element[0].blur();
                event.preventDefault();
            }
        });
    }
}

export default BlurConEnterDirective;


// WEBPACK FOOTER //
// ./src/busqueda/directivas/blur-con-enter.directive.js